import { createContext } from "react";
import { TabsContextProps } from "./types";

const TabsContext = createContext<TabsContextProps | undefined>(undefined);

export { TabsContext };
